import styled, { AnyStyledComponent } from 'styled-components';
import { OverflowTypes } from './buttonGroup.types';


interface ButtonGroupWrapperProps {
  inline: boolean;
  overflow: OverflowTypes;
};

export const ButtonGroupWrapper: AnyStyledComponent = styled.div<ButtonGroupWrapperProps>`
  display: flex;
  flex-direction: ${({ inline }) => inline ? 'row' : 'column'};
  overflow: ${({ overflow }) => overflow ? overflow : OverflowTypes.VISIBLE};
  overflow-x: ${({ overflow, inline }) => overflow && inline ? overflow : OverflowTypes.VISIBLE};
  overflow-y: ${({ overflow, inline }) => overflow && !inline ? overflow : OverflowTypes.VISIBLE};
  -webkit-overflow-scrolling: touch;
`;
